export const thumbOverPartsUpperOfUsModel = (ctx: CanvasRenderingContext2D, leatherColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = leatherColor
  ctx.beginPath()
  ctx.moveTo(411, 477) // ラベル頂点
  ctx.quadraticCurveTo(390, 555, 390, 555) // ラベル左下
  ctx.quadraticCurveTo(495, 500, 495, 500) // ラベル右上
  ctx.quadraticCurveTo(595, 396, 635, 370) // 親指上分岐
  ctx.quadraticCurveTo(649, 362, 660, 376) //
  ctx.quadraticCurveTo(700, 321, 735, 284) // 親指右頂点
  ctx.quadraticCurveTo(732, 263, 713, 269) // 親指左頂点
  ctx.quadraticCurveTo(497, 433, 497, 433) // 折り返し右下
  ctx.quadraticCurveTo(483, 471, 411, 477) // ラベル頂点
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // // stitch
  // ctx.lineWidth = 1.2
  // ctx.strokeStyle = stitchColor
  // ctx.beginPath()
  // ctx.setLineDash([3, 3])
  // // 手口
  // ctx.moveTo(340, 587) // 手口＿左
  // ctx.quadraticCurveTo(430, 598, 529, 585) // 手口＿右
  // ctx.stroke()
  // ctx.setLineDash([])
  // ctx.lineWidth = 0.8
  // ctx.strokeStyle = '#383838'
  // ctx.closePath()
  // // stitch
}

export const thumbAndListBeltOfUsModel = (ctx: CanvasRenderingContext2D, leatherColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = leatherColor
  ctx.beginPath()
  ctx.moveTo(291, 490) // ベルト左上
  ctx.quadraticCurveTo(319, 538, 340, 588) // ベルト左下
  ctx.quadraticCurveTo(425, 602, 525, 586) //
  ctx.quadraticCurveTo(581, 537, 620, 478) //
  ctx.quadraticCurveTo(662, 376, 662, 376) // 親指途中_分岐頂点
  ctx.quadraticCurveTo(644, 352, 618, 381) //
  ctx.quadraticCurveTo(492, 495, 492, 495) // ATOMSラベル右上
  ctx.quadraticCurveTo(410, 477, 410, 477) // ATOMSラベル中央頂点
  ctx.quadraticCurveTo(291, 490, 291, 490) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // // stitch
  // ctx.lineWidth = 1.2
  // ctx.strokeStyle = stitchColor
  // ctx.beginPath()
  // ctx.setLineDash([3, 3])
  // // 手口
  // ctx.moveTo(340, 587) // 手口＿左
  // ctx.quadraticCurveTo(430, 598, 529, 585) // 手口＿右
  // ctx.stroke()
  // ctx.setLineDash([])
  // ctx.lineWidth = 0.8
  // ctx.strokeStyle = '#383838'
  // ctx.closePath()
  // // stitch
}

export const thumbOutOfUsModel = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.moveTo(737, 284) // 左上
  ctx.quadraticCurveTo(693, 330, 661, 377) // 左下
  ctx.quadraticCurveTo(647, 394, 618, 482)
  ctx.quadraticCurveTo(671, 391, 730, 320) //
  ctx.quadraticCurveTo(748, 295, 739, 283) // 左上/
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
